import * as Sentry from '@sentry/react';
import { type ReactElement, type ReactNode } from 'react';

import { FeatureErrorState } from '@/components/feature-error-state.tsx';

type FallbackProps = Parameters<Sentry.FallbackRender>[0];

interface Props {
    children: ReactNode;
    featureName: string;
}

const fallback = (props: FallbackProps): ReactElement => {
    const handleRetry = (): void => props.resetError();
    return <FeatureErrorState onRetry={handleRetry} />;
};

export const FeatureErrorBoundary = ({ children, featureName }: Props) => {
    return (
        <Sentry.ErrorBoundary
            fallback={fallback}
            beforeCapture={(scope) => {
                scope.setTag('boundary', 'feature');
                scope.setTag('feature', featureName);
            }}
        >
            {children}
        </Sentry.ErrorBoundary>
    );
};
